<template>
  <div class="dw-api-view">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="转发API管理" name="api">
        <div class="toolbar">
          <el-button type="primary" @click="showAddApiForm">添加API</el-button>

          <div class="search-box">
            <el-input v-model="searchParams.label" placeholder="接口标签" style="width: 150px" clearable />
            <el-input v-model="searchParams.title" placeholder="接口名称" style="width: 150px; margin-left: 10px" clearable />
            <el-input v-model="searchParams.method" placeholder="请求方法" style="width: 120px; margin-left: 10px" clearable />
            <el-select v-model="searchParams.type" placeholder="类型" style="width: 120px; margin-left: 10px" clearable>
              <el-option label="全部" :value="``" />
              <el-option label="指定数据库" :value=-1 />
              <el-option label="查询DataWorks" :value=0 />
              <el-option label="查询埋点的RDS" :value=1 />
              <el-option label="外部Http同步" :value=2 />
              <el-option label="外部Http异步" :value=3 />
            </el-select>
          </div>
        </div>

        <el-table :data="filteredApiList" style="width: 100%">
          <el-table-column prop="label" min-width="220" label="接口标签" />
          <el-table-column prop="title" min-width="200" label="接口名称" />
          <el-table-column prop="method" min-width="200" label="请求方法" />
          <el-table-column prop="type" min-width="140" label="类型">
            <template #default="{row}">
              {{ getTypeName(row.type) }}
            </template>
          </el-table-column>
          <el-table-column prop="add_time" min-width="160" label="创建时间" />
          <el-table-column label="操作" min-width="380">
            <template #default="{row}">
              <el-button class="report-button" size="small" type="primary" @click="handleEditApi(row)">编辑</el-button>
              <el-button class="report-button" size="small" @click="handleCloneApi(row)">克隆</el-button>
              <el-button class="report-button" size="small" type="success" @click="handleCopyRequestApi(row)">复制参数</el-button>
              <el-button class="report-button" size="small" type="warning" @click="handleDebugApi(row)">接口调试</el-button>
              <el-button class="report-button" size="small" type="danger" @click="handleDeleteApi(row.id)" v-if="isToday(row.add_time)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog v-model="showApiDialog" :title="apiDialogTitle" width="60%">
          <el-form :model="apiForm" label-width="120px" :rules="apiRules" ref="apiFormRef">
            <el-form-item label="接口标签" prop="label">
              <el-input v-model="apiForm.label" />
            </el-form-item>
            <el-form-item label="接口名称" prop="title">
              <el-input v-model="apiForm.title" />
            </el-form-item>
            <el-form-item label="请求方法" prop="method">
              <el-input v-model="apiForm.method" />
            </el-form-item>
            <el-form-item label="接口类型" prop="type">
              <el-select v-model="apiForm.type" @change="handleTypeChange">
                <el-option label="指定数据库" :value=-1 />
                <el-option label="查询DataWorks" :value=0 />
                <el-option label="查询埋点的RDS" :value=1 />
                <el-option label="外部Http同步" :value=2 />
                <el-option label="外部Http异步" :value=3 />
              </el-select>
            </el-form-item>

            <!-- 根据不同类型显示不同表单内容 -->
            <template v-if="apiForm.type === -1 || apiForm.type === 0 || apiForm.type === 1">
              <el-form-item label="SQL语句" prop="content.sql">
                <el-input type="textarea" v-model="apiForm.content.sql" :rows=5 />
              </el-form-item>
            </template>

            <template v-if="apiForm.type === 1">
              <el-form-item label="组织ID" prop="content.orgId">
                <el-input v-model="apiForm.content.orgId" />
              </el-form-item>
            </template>

            <template v-if="apiForm.type === 2 || apiForm.type === 3">
              <el-form-item label="请求URL" prop="content.url">
                <el-input v-model="apiForm.content.url" />
              </el-form-item>
              <el-form-item label="请求方法" prop="content.method">
                <el-select v-model="apiForm.content.method">
                  <el-option label="GET" value="GET" />
                  <el-option label="POST" value="POST" />
                </el-select>
              </el-form-item>
              <el-form-item label="请求体" prop="content.body">
                <el-input type="textarea" v-model="bodyJson" :rows=5 />
              </el-form-item>
              <el-form-item v-if="apiForm.type === 3" label="WebHook URL" prop="content.webHookUrl">
                <el-input v-model="apiForm.content.webHookUrl" />
              </el-form-item>
            </template>

            <el-form-item label="参数映射">
              <div class="paramMapping" v-for="(value, key) in apiForm.content.paramMapping" :key="key">
                {{ key }} → {{ value }}
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitApiForm">提交</el-button>
              <el-button @click="resetApiForm">重置</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>

        <!-- 接口调试对话框 -->
        <el-dialog v-model="showDebugDialog" title="接口调试" width="50%">
          <el-form label-width="120px">
            <el-form-item label="AppKey" required>
              <el-select v-model="debugForm.appKey" placeholder="请选择AppKey" style="width: 100%">
                <el-option v-for="item in appKeyList" :key="item.id" :label="`${item.appKey}:${item.appSecret}`" :value="`${item.appKey}:${item.appSecret}`" />
              </el-select>
            </el-form-item>

            <el-form-item label="请求方法">
              <el-input v-model="debugForm.method" disabled />
            </el-form-item>

            <el-form-item v-for="(value, key) in debugForm.params" :key="key" :label="key">
              <el-input v-model="debugForm.params[key]" />
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="debugApi" :loading="debugLoading">
                开始调试
              </el-button>
            </el-form-item>

            <el-form-item label="响应结果">
              <div class="debug-result">
                <vue-json-pretty v-if="debugResult && debugResult !== 'Loading...'" :data="JSON.parse(debugResult)" :deep="5" :showLength="true" :showLine="true" :showDoubleQuotes="true" />
                <el-skeleton v-else :rows="5" animated />
              </div>
              <el-button v-if="debugResult && debugResult !== 'Loading...'" type="primary" @click="copyDebugResult" style="margin-top: 10px">
                复制结果
              </el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </el-tab-pane>

      <el-tab-pane label="AppKey管理" name="appKey">
        <div class="toolbar">
          <el-button type="primary" @click="showAppKeyForm">添加AppKey</el-button>
          <el-input v-model="appKeySearch" placeholder="搜索AppKey" style="width: 200px; margin-left: 10px" clearable />
        </div>

        <AppKeyList :appKeys="appKeyList" :searchKey="appKeySearch" @delete="handleDeleteAppKey" />

        <el-dialog v-model="showAppKeyDialog" title="添加AppKey" width="40%">
          <AppKeyForm @submit="handleAppKeySubmit" />
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
import AppKeyList from '@/components/dwApi/AppKeyList.vue'
import AppKeyForm from '@/components/dwApi/AppKeyForm.vue'
import { CopyDocument, Refresh } from '@element-plus/icons-vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import {
  getForwardApiList,
  createForwardApi,
  updateForwardApi,
  deleteForwardApi,
  getAppKeyList,
  createAppKey,
  deleteAppKey,
  debugRestApi
} from '@/utils/restApi'

// 响应式状态
const activeTab = ref('api')
const apiList = ref([])
const appKeyList = ref([])
const apiForm = ref({
  label: '',
  title: '',
  method: '',
  type: '',
  content: {
    sql: '',
    url: '',
    method: '',
    body: '',
    webHookUrl: '',
    orgId: '',
    paramMapping: {}
  }
});
const errorMessage = ref('');
const bodyJson = ref('');

watch(() => apiForm.value.content.body, (newVal) => {
  bodyJson.value = JSON.stringify(newVal || {}, null, 2);
}, { deep: true, immediate: true });

watch(bodyJson, (newVal) => {
  try {
    apiForm.value.content.body = JSON.parse(newVal);
    errorMessage.value = '';
  } catch (e) {
    errorMessage.value = 'JSON格式错误: ' + e.message;
  }
});
watch(
  [
    () => apiForm.value.content.sql,
    () => apiForm.value.content.body,  // 这里如果是字符串，直接监听字符串变化就可以
    () => apiForm.value.content.url,
    () => apiForm.value.content.method,
    () => apiForm.value.content.webHookUrl,
    () => bodyJson.value
  ],
  () => {
    extractParams(apiForm.value.content);
  }
);

const initApiForm = {
  label: '',
  title: '',
  method: '',
  type: '',
  content: {
    sql: '',
    url: '',
    method: '',
    body: '',
    webHookUrl: '',
    orgId: '',
    paramMapping: {}
  }
}
const apiRules = ref({
  label: [
    { required: true, message: '请输入接口标签', trigger: 'blur' }
  ],
  title: [
    { required: true, message: '请输入接口名称', trigger: 'blur' }
  ],
  method: [
    { required: true, message: '请输入请求方法', trigger: 'blur' }
  ],
  type: [
    { required: true, message: '请选择接口类型', trigger: 'blur' }
  ],
  'content.sql': [
    { required: true, message: '请输入SQL语句', trigger: 'blur' }
  ],
  'content.url': [
    { required: true, message: '请输入请求URL', trigger: 'blur' }
  ],
  'content.method': [
    { required: true, message: '请选择请求方法', trigger: 'change' }
  ]
})
const apiFormRef = ref(null);
const isEditApi = ref(false)
const showApiDialog = ref(false)
const showAppKeyDialog = ref(false)

// 调试相关状态
const showDebugDialog = ref(false)
const debugLoading = ref(false)
const debugResult = ref('')
const debugForm = ref({
  appKey: '',
  method: '',
  params: {}
})
const currentDebugRow = ref(null)
const appKeySearch = ref('')
const searchParams = ref({
  label: '',
  title: '',
  method: '',
  type: null
})

// 计算属性
const filteredApiList = computed(() => {
  return apiList.value.filter(api => {
    const matchesLabel = searchParams.value.label
      ? api.label.includes(searchParams.value.label)
      : true
    const matchesTitle = searchParams.value.title
      ? api.title.includes(searchParams.value.title)
      : true
    const matchesMethod = searchParams.value.method
      ? api.method.includes(searchParams.value.method)
      : true
    const matchesType = searchParams.value.type !== null && searchParams.value.type !== undefined && searchParams.value.type !== ''
      ? api.type === searchParams.value.type
      : true
    return matchesLabel && matchesTitle && matchesMethod && matchesType
  })
})

const apiDialogTitle = computed(() => {
  if (!apiForm.value) return '添加API'
  if (apiForm.value.label?.endsWith('_克隆')) return '克隆API'
  return isEditApi.value ? '编辑API' : '添加API'
})

// 方法
const getTypeName = (type) => {
  switch (type) {
    case -1: return '指定数据库'
    case 0: return '查询DataWorks'
    case 1: return '查询埋点的RDS'
    case 2: return '外部Http同步'
    case 3: return '外部Http异步'
    default: return '未知类型'
  }
}

const isToday = (dateStr) => {
  const date = new Date(dateStr)
  const today = new Date()
  return date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate()
}

const resetApiForm = () => {
  // apiFormRef.value?.resetFields();
  // 1. 先清除校验状态
  apiFormRef.value?.clearValidate();
  apiForm.value = JSON.parse(JSON.stringify(initApiForm)); // 深拷贝，避免引用
};

const showAddApiForm = () => {
  resetApiForm();
  isEditApi.value = false
  showApiDialog.value = true
}

const showEditApiForm = (api) => {
  apiFormRef.value?.clearValidate();
  Object.assign(apiForm.value, {
    ...api,
    content: (() => {
      try {
        return typeof api.content === 'string' ? JSON.parse(api.content) : api.content;
      } catch (e) {
        return api.content; // 返回原值或默认值
      }
    })()
  });
  extractParams(api.content)
  isEditApi.value = true
  showApiDialog.value = true
}

const showCloneApiForm = (api) => {
  Object.assign(apiForm.value, {
    ...api,
    content: typeof api.content === 'string' ? JSON.parse(api.content) : api.content,
    label: `${api.label}_克隆`,
    title: `${api.title}_克隆`
  })
  delete apiForm.value.id
  extractParams(apiForm.value.content)
  isEditApi.value = false
  showApiDialog.value = true
}
const handleEditApi = (api) => {
  showEditApiForm(api)
}

const handleCloneApi = (api) => {
  showCloneApiForm(api)
}

const handleDebugApi = (row) => {
  currentDebugRow.value = row
  debugResult.value = '';
  debugForm.value = {
    appKey: '',
    method: row.method,
    params: {}
  }

  // 初始化参数
  const content = typeof row.content === 'string' ? JSON.parse(row.content) : row.content
  const paramMapping = content.paramMapping || {}
  Object.values(paramMapping).forEach(key => {
    debugForm.value.params[key] = ''
  })

  showDebugDialog.value = true
}

const debugApi = async () => {
  try {
    debugLoading.value = true
    debugResult.value = 'Loading...'

    const requestBody = {}
    Object.entries(debugForm.value.params).forEach(([key, value]) => {
      requestBody[key] = value
    })
    if (!debugForm.value.appKey) {
      ElMessage.error('请先选择AppKey');
      return;
    }
    const result = await debugRestApi(
      debugForm.value.method,
      requestBody,
      debugForm.value.appKey.split(':')[0], // appKey
      debugForm.value.appKey.split(':')[1]  // appSecret
    )

    debugResult.value = JSON.stringify(result, null, 2)
  } catch (error) {
    console.error('接口调试失败:', error)
    debugResult.value = `Error: ${error.message}`
  } finally {
    debugLoading.value = false
  }
}

const copyDebugResult = () => {
  navigator.clipboard.writeText(debugResult.value)
    .then(() => {
      ElMessage.success('复制成功')
    })
    .catch(err => {
      console.error('复制失败:', err)
      ElMessage.error('复制失败')
    })
}

const handleDeleteApi = async (id) => {
  try {
    await ElMessageBox.confirm(
      '确定要删除此 API 吗？此操作不可恢复。',
      '提示',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    )

    // 用户点击“确定”后执行删除
    await deleteForwardApi(id)
    ElMessage.success('删除成功')
    loadApiList()

  } catch (error) {
    // 如果是点击取消，不需要提示错误
    if (error !== 'cancel' && error !== 'close') {
      console.error('删除API失败:', error)
      ElMessage.error('删除失败')
    }
  }
}

const handleCopyRequestApi = (api) => {
  if (!api || !api.content) {
    ElMessage.warning('没有可复制的请求参数');
    return;
  }

  const content = JSON.parse(api.content);
  const params = content.paramMapping || {};

  const requestBody = Object.fromEntries(
    Object.values(params).map(k => [k, ""])
  );

  const copyText = `
================ 请求地址 ================
莫凡公网：
https://dataworks-api.morefun.me/admin/api/tracking/route/rest

阿里域名空间：
http://dataworks-api.config.svc.cluster.local:8080/admin/api/tracking/route/rest

=============== 请求头 ===============
{
  "Content-Type": "application/json",
  "uuid": "",
  "key": "",
  "timestamp": "",
  "sign": ""
}

============== 请求参数 ==============
{
  "method": "${api.method}",
  "requestBody": ${JSON.stringify(requestBody, null, 2)}
}
`;

  navigator.clipboard.writeText(copyText)
    .then(() => {
      ElMessage.success('请求参数已复制到剪贴板');
    })
    .catch(err => {
      console.error('复制失败:', err);
      ElMessage.error('复制失败');
    });
};
const submitApiForm = async () => {
  apiFormRef.value.validate((valid) => {
    if (valid) {
      handleApiSubmit(apiForm.value)
    } else {
      console.log('表单验证失败')
      return false;
    }
  })
}
const handleApiSubmit = async (formData) => {
  try {
    // 自动提取参数映射
    extractParams(formData.content)

    if (isEditApi.value) {
      await updateForwardApi(formData.id, formData)
    } else {
      await createForwardApi(formData)
    }
    showApiDialog.value = false
    loadApiList()
  } catch (error) {
    console.error('保存API失败:', error)
  }
}
const handleTypeChange = (type) => {
  // 根据类型重置相关内容
  apiForm.value.content = {
    sql: '',
    url: '',
    method: '',
    body: '',
    webHookUrl: '',
    orgId: '',
    paramMapping: {}
  }
  apiForm.value.type = type;

  // 重新提取参数映射
  extractParams(apiForm.value.content)
}
const extractParams = (content) => {
  if (!content) {
    return {};
  }

  const regex = /#\{([^}]+)\}/g
  let match
  const foundParams = {}

  // 深度遍历对象查找参数
  const traverse = (obj) => {
    if (typeof obj === 'string') {
      let str = obj
      while ((match = regex.exec(str))) {
        const param = match[1]
        foundParams[`#{${param}}`] = param
      }
    } else if (typeof obj === 'object' && obj !== null) {
      Object.values(obj).forEach(value => {
        traverse(value)
      })
    }
  }

  traverse(content)

  // 清理已不存在的参数映射
  const newParamMapping = {}
  Object.keys(apiForm.value?.content?.paramMapping || {}).forEach(key => {
    if (foundParams[key]) {
      newParamMapping[key] = apiForm.value.content.paramMapping[key]
    }
  })

  // 添加新发现的参数
  Object.keys(foundParams).forEach(key => {
    if (!newParamMapping[key]) {
      newParamMapping[key] = foundParams[key]
    }
  })

  if (apiForm.value) {
    apiForm.value.content.paramMapping = newParamMapping
  }
}


const loadApiList = async () => {
  try {
    const data = await getForwardApiList()
    apiList.value = Array.isArray(data) ? data : []
  } catch (error) {
    console.error('加载API列表失败:', error)
    apiList.value = []
  }
}


const showAppKeyForm = () => {
  showAppKeyDialog.value = true
}
const handleAppKeySubmit = async (formData) => {
  try {
    await createAppKey(formData)
    showAppKeyDialog.value = false
    loadAppKeyList()
  } catch (error) {
    console.error('添加AppKey失败:', error)
  }
}
const handleDeleteAppKey = async (id) => {
  try {
    await deleteAppKey(id)
    loadAppKeyList()
  } catch (error) {
    console.error('删除AppKey失败:', error)
  }
}
const loadAppKeyList = async () => {
  try {
    const data = await getAppKeyList()
    appKeyList.value = Array.isArray(data) ? data : []
  } catch (error) {
    console.error('加载AppKey列表失败:', error)
    appKeyList.value = []
  }
}

// 生命周期
onMounted(() => {
  loadApiList()
  loadAppKeyList()
})

// 暴露给模板的方法
defineExpose({
  activeTab,
  apiList,
  filteredApiList,
  appKeyList,
  apiForm,
  isEditApi,
  showApiDialog,
  showAppKeyDialog,
  appKeySearch,
  searchParams,
  getTypeName,
  isToday,
  resetApiForm,
  apiDialogTitle,
  showAddApiForm,
  // 其他需要暴露的方法...
})
</script>

<style scoped>
.report-button {
  margin-left: 2px !important;
  margin-right: 2px !important;
  min-width: auto !important; /*防止按钮宽度被撑开*/
}
/* 样式保持不变 */
.dw-api-view {
  padding: 20px;
}
.toolbar {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}
.search-box {
  margin-left: 20px;
  display: flex;
  align-items: center;
}
.paramMapping {
  background: #ffffff;
  border: 1px solid #ebeef5;
  padding: 10px 16px;
  margin-bottom: 8px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  font-size: 14px;
  color: #303133;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.debug-result {
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  padding: 10px;
  border-radius: 4px;
  max-height: 300px;
  overflow: auto;
}

.debug-result {
  max-height: 400px;
  overflow: auto;
  padding: 10px;
  background: #f8f8f8;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}
</style>
